import { createPubSub } from './createPubSub'
import {
    alertsInterceptors,
    listInterceptors,
    userInterceptors,
} from './interceptors'

export const pubSubAlerts = createPubSub('ALERTS_', alertsInterceptors)
export const pubSubAppState = createPubSub('APPSTATE_')
export const pubSubChatCommands = createPubSub('CHAT_COMMANDS_')
export const pubSubLayout = createPubSub('LAYOUT_')
export const pubSubMail = createPubSub('MAIL_')
export const pubSubMessages = createPubSub('MESSAGES_')
export const pubSubArchives = createPubSub('ARCHIVES_')
// export const pubSubModal = createPubSub('MODAL_')
export const pubSubNotes = createPubSub('NOTES_')
export const pubSubMyml = createPubSub('MYML_')
// export const pubSubRoom = createPubSub('ROOM_')
export const pubSubRoomHistory = createPubSub('ROOMHISTORY_')
export const pubSubSearch = createPubSub('SEARCH_')
export const pubSubSecureState = createPubSub('SECURESTATE_')
export const pubSubSettings = createPubSub('SETTINGS_')
export const pubSubSidebar = createPubSub('SIDEBAR_')
export const pubSubTimer = createPubSub('TIMER_')
export const pubSubWhiteboard = createPubSub('WHITEBOARD_')
export const pubSubVideo = createPubSub('VIDEO_')
export const pubSubList = createPubSub('LIST_', listInterceptors)
export const pubSubUsers = createPubSub('USERS_', userInterceptors)
export const pubSubRouter = createPubSub('ROUTE_')
export const pubSubNews = createPubSub('NEWS_')

if (typeof window !== 'undefined') {
    window.__MFC_APP_TEST_TOOLS__ = { pubSubSettings }
}
